const PATH = "/geeta/api/v1";

const ENDPOINTS = {
    AVATAR_ASSETS:"/avatar/asset/",
    AVATAR_CATEGORY:"/avatar/category/",
};

export type GeetaEndpoints = keyof typeof ENDPOINTS;
export const GeetaCollection = { PATH, ENDPOINTS };
